<template>
  <div>
    <slot v-if="revealed"></slot>
  </div>
</template>

<script>
export default {
  name: 'TabContentLazy',
  data() {
    return {
      revealed: false
    }
  },
  mounted() {
    const panel = this.$el.closest('.product-tabs__accordion-content')
    if (!panel) return

    // If already open when mounted (e.g. first tab), reveal immediately
    if (panel.getAttribute('aria-hidden') === 'false') {
      this.revealed = true
      return
    }

    this._observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'aria-hidden' &&
          panel.getAttribute('aria-hidden') === 'false'
        ) {
          this.revealed = true
          this._observer.disconnect()
          break
        }
      }
    })

    this._observer.observe(panel, { attributes: true, attributeFilter: ['aria-hidden'] })
  },
  beforeDestroy() {
    if (this._observer) {
      this._observer.disconnect()
    }
  }
}
</script>
